<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      visible
      direction="rtl"
      :size="800"
      show-close
      @close="close"
      :before-close="handleClose"
      append-to-body
    >
      <div>
        <div class="spec-info__container">
          <div class="spec-info__wrapper d-flex">
            <div class="spec-img__wrapper">
              <el-image
                :src="
                  formData.defaultImageUrl
                    ? $osscdn(formData.defaultImageUrl)
                    : '/image/static/img/nopic.jpg'
                "
                :preview-src-list="[
                  formData.defaultImageUrl || '/image/static/img/nopic.jpg',
                ]"
                class="spec-img"
                fit="cover"
              >
                <div slot="error" class="image-slot">
                  <img src="/image/static/img/nopic.jpg" class="spec-img" />
                </div>
              </el-image>
              <br />
              <el-button
                class="button_class"
                @click="openImgChoose"
                size="mini"
                v-if="!disabled"
                >{{
                  $l('INDEX.evg_sku_label_edit_picture') || '编辑图片'
                }}</el-button
              >
            </div>

            <div class="spec-detail__wrapper">
              <el-form
                ref="form"
                :model="formData"
                :disabled="disabled"
                :rules="rules"
                size="mini"
              >
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item
                      :label="$l('INDEX.evg_sku_label_specNo') || '规格编号'"
                    >
                      <el-input
                        v-model="formData.sampleStyleNo"
                        :placeholder="
                          $l('INDEX.tips_input_placeholder') || '请输入...'
                        "
                        readonly
                        :disabled="disabled"
                        size="mini"
                        style="width: 100%"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="' '">
                      <div style="margin-top: 35px">
                        {{
                          $l('INDEX.evg_sku_label_auto') ||
                          '系统自动生成的编号，不需手工录入'
                        }}
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item
                      :label="$l('INDEX.evg_sku_label_specName') || '规格名称'"
                      prop="sampleSpecName"
                    >
                      <el-input
                        v-model="formData.sampleSpecName"
                        :placeholder="
                          $l('INDEX.tips_input_placeholder') || '请输入...'
                        "
                        :disabled="disabled"
                        maxlength="200"
                        clearable
                        size="mini"
                        style="width: 100%"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      :label="
                        $l('INDEX.evg_sku_label_specNameEn') || '规格名称英文'
                      "
                      prop="sampleSpecNameEn"
                    >
                      <el-input
                        v-model="formData.sampleSpecNameEn"
                        :placeholder="
                          $l('INDEX.tips_input_placeholder') || '请输入...'
                        "
                        :disabled="disabled"
                        maxlength="200"
                        clearable
                        size="mini"
                        style="width: 100%"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="4">
                    <el-form-item
                      :label="$l('INDEX.evg_sku_label_goodsLength') || '长'"
                      prop="goodsLength"
                    >
                      <el-input-number
                        controls-position="right"
                        style="width: 100%"
                        size="mini"
                        :disabled="disabled"
                        :min="0"
                        :step="0.01"
                        :placeholder="
                          $l('INDEX.tips_input_placeholder') || '请输入...'
                        "
                        v-model="formData.goodsLength"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item
                      :label="$l('INDEX.evg_sku_label_goodsWidth') || '宽'"
                      prop="goodsWidth"
                    >
                      <el-input-number
                        controls-position="right"
                        style="width: 100%"
                        size="mini"
                        :disabled="disabled"
                        :min="0"
                        :step="0.01"
                        :placeholder="
                          $l('INDEX.tips_input_placeholder') || '请输入...'
                        "
                        v-model="formData.goodsWidth"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item
                      :label="$l('INDEX.evg_sku_label_goodsHeight') || '高'"
                      prop="goodsHeight"
                    >
                      <el-input-number
                        controls-position="right"
                        style="width: 100%"
                        size="mini"
                        :disabled="disabled"
                        :min="0"
                        :step="0.01"
                        :placeholder="
                          $l('INDEX.tips_input_placeholder') || '请输入...'
                        "
                        v-model="formData.goodsHeight"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      :label="$l('INDEX.evg_sku_label_specUnit') || '规格单位'"
                      prop="specUnit"
                    >
                      <dict-select
                        size="mini"
                        :disabled="disabled"
                        clearable
                        filterable
                        v-model="formData.specUnit"
                        url="/master/common/dict/biz"
                        :body="{ dictType: 'specUnit' }"
                      ></dict-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      :label="$l('INDEX.evg_sku_label_specQty') || '规格数量'"
                      prop="qty"
                    >
                      <el-input-number
                        controls-position="right"
                        style="width: 100%"
                        size="mini"
                        :disabled="disabled"
                        :precision="0"
                        :min="0"
                        :step="1"
                        :placeholder="
                          $l('INDEX.tips_input_placeholder') || '请输入...'
                        "
                        v-model="formData.qty"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
        <div v-if="paramCode">
          <div class="d-flex mb-2" style="align-items: center">
            <div class="title-text">
              {{ $l('title_text_fabric_info') || '面料信息' }}
            </div>
            <el-button
              class="ml-4"
              type="primary"
              plain
              size="mini"
              @click="onOpenChooseFabric"
              >{{ $l('btn_choose_fabric') || '选择面料' }}</el-button
            >
          </div>
          <div
            v-for="(fabricItem, index) in fabircList"
            :key="fabricItem.proofingSampleDetialFabricCode || fabricItem.id"
          >
            <FabricInfo
              ref="fabricInfo"
              :item="fabricItem"
              :disabled="disabled"
              @delFabric="onDelFabric(index)"
            />
          </div>
        </div>
        <div class="d-flex justify-content-end mb-2 mt-3">
          <el-button
            type="primary"
            size="small"
            style="width: 100px"
            @click="save"
            v-if="!disabled"
            >{{ $l('INDEX.btn_save') || '保存' }}</el-button
          >
        </div>
      </div>
    </el-drawer>
    <ChooseFabricColor
      v-if="openChooseFabricVisible"
      @chooseFabric="onChooseFabric"
      @close="closeChooseFabric"
      :visible="openChooseFabricVisible"
    ></ChooseFabricColor>
    <ImageChoose
      :proofingCode="proofingCode"
      :visible.sync="showImageChoose"
      v-if="showImageChoose"
      :title="$l('INDEX.evg_sku_label_image_maintenance') || '图片维护'"
      @setImage="setImage"
    >
    </ImageChoose>
  </div>
</template>
<script>
import ImageChoose from '../../image-choose'
import FabricInfo from './fabric-info'
import ChooseFabricColor from './choose-fabric-color'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    proofingCode: {
      type: String,
      default: '',
    },
    proofingSampleCode: {
      type: String,
      default: '',
    },
    proofingSampleDetialCode: {
      type: String,
      default: '',
    },
  },
  components: { FabricInfo, ChooseFabricColor, ImageChoose },
  mixins: [EditLoading],
  data() {
    return {
      formData: {
        defaultImageCode: '',
        defaultImageUrl: '',
      },
      openChooseFabricVisible: false,
      saveReturnCode: '',
      rules: {
        sampleSpecName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
        ],
        sampleSpecNameEn: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
        ],
        goodsLength: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
        ],
        goodsWidth: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
        ],
        goodsHeight: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
        ],
        specUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        qty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
        ],
      },
      fabircList: [],
      showImageChoose: false,
    }
  },
  computed: {
    paramCode() {
      return !this.proofingSampleDetialCode
        ? this.saveReturnCode
        : this.proofingSampleDetialCode
    },
    forKey() {
      return Math.random()
    },
  },
  async mounted() {
    await this.getData()
    await this.getFabricList()
  },
  methods: {
    async getData() {
      if (this.paramCode) {
        const res = await this.$api
          .customerProofingSampleDetailDetailApi({
            proofingSampleDetialCode: this.paramCode,
          })
          .catch(() => {})
        this.formData = { ...res.body }
      }
    },
    async getFabricList() {
      if (this.paramCode) {
        const res = await this.$api
          .customerProofingSampleDetailFabricListApi({
            proofingSampleDetialCode: this.paramCode,
          })
          .catch(() => {})
        this.fabircList = res?.body?.data || []
      }
    },
    async openImgChoose() {
      this.showImageChoose = true
    },
    async setImage({ displayImageCode, displayImageUrl }) {
      this.formData.defaultImageCode = displayImageCode
      this.formData.defaultImageUrl = displayImageUrl
      this.showImageChoose = false
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      const fiRefs = this.$refs.fabricInfo || []
      const fabricData = []
      for (let i = 0; i < fiRefs.length; i++) {
        if (fiRefs[i]) {
          const fd = fiRefs[i].getFabricData()
          const res = await fiRefs[i].validateForm()
          if (!res) {
            return
          }
          fabricData.push(fd)
        }
      }
      this.loadingOpen()
      const params = {
        ...this.formData,
        proofingCode: this.proofingCode,
        proofingSampleCode: this.proofingSampleCode,
        fabricList: fabricData,
      }
      const res = await this.$api
        .customerProofingSampleDetailSaveApi({ ...params })
        .catch(() => null)

      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败')
        return
      }
      this.saveReturnCode = res.body
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功',
        type: 'success',
      })
      await this.getData()
      this.$emit('reload')
    },
    onOpenChooseFabric() {
      this.openChooseFabricVisible = true
    },
    closeChooseFabric() {
      this.openChooseFabricVisible = false
    },
    onChooseFabric(fabric) {
      this.fabircList.splice(0, 0, { ...fabric, id: Math.random() })
    },
    onDelFabric(index) {
      this.fabircList.splice(index, 1)
    },
    close() {
      if (!this.disabled) this.$emit('reload')
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    handleClose(done) {
      if (this.disabled) {
        this.close()
        return
      }
      this.$confirm(
        this.$l('INDEX.tips_check_saved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.product_dialog_btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  padding: 0 20px 12px;
}
::v-deep .el-drawer__header {
  align-items: center;
  color: #141516;
  display: flex;
  margin-bottom: 12px;
  padding: 10px 20px 0;
}
.spec-info__container {
  margin-top: 10px;
  border-radius: 5px;
  color: #101010;
  padding: 15px 0;
  .spec-img__wrapper {
    .spec-img {
      width: 120px;
      height: 120px;
      border: 1px dashed #cecece;
      border-radius: 5px;
      margin-bottom: 5px;
      padding: 6px;
      margin-top: 10px;
      > img {
        width: 108px;
        height: 108px;
        border-radius: 3px;
      }
    }
    > img {
      width: 96px;
      height: 96px;
      border-radius: 3px;
    }
  }

  .spec-detail__wrapper {
    flex: 1;
    margin-left: 15px;
    .modify-info {
      display: flex;
      align-items: flex-end;
      color: #8e8e8e;
      font-size: 14px;
    }
  }
}
.button_class {
  width: 120px;
  height: 30px;
  line-height: 2px;
  border-radius: 4px !important;
}
.title-text {
  height: 23px;
  line-height: 23px;
  color: #303133;
  font-size: 16px;
  font-weight: 600;
}
</style>
